import { createFeatureSelector } from '@ngrx/store';
import {
  CreateNewTagManagementState,
  SearchTagsState,
  SideNavState,
  TagAssignmentState,
} from '../models/search-filters.model';
import { createNewTagReducer } from './create-new-tag.reducer';
import { DateReducer, EditDate } from './edit-date.reducer';
import { TagManagementReducer } from './search-tags.reducer';
import { TagAssignmentReducer } from './tag-assignment.reducer';
import { SideNavReducer } from './tag-management.reducer';
import { UpdateTag, UpdateTagReducer } from './update-tag.reducer';

export const featureTagManagementName = 'TagManagement';

export interface DragonflyState {
  tagManagement: SearchTagsState;
  createNewTagManagement: CreateNewTagManagementState;
  updateTag: UpdateTag;
  tagAssignment: TagAssignmentState;
  editDate: EditDate;
  sideNav: SideNavState;
}

export const moduleTagManagementReducers = {
  tagManagement: TagManagementReducer,
  createNewTagManagement: createNewTagReducer,
  updateTag: UpdateTagReducer,
  tagAssignment: TagAssignmentReducer,
  editDate: DateReducer,
  sideNav: SideNavReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(
  featureTagManagementName
);
